import React from 'react'

import { Skeleton } from '@/shared/components/atoms/Skeleton'
import { cn } from '@/shared/utils/helpers'

interface PlaylistSkeletonProps {
	count?: number
	className?: string
}

const PlaylistSkeleton: React.FC<PlaylistSkeletonProps> = ({
	count = 10,
	className = '',
}) => {
	return (
		<div
			className={cn(
				'flex gap-2 lg:gap-4 overflow-x-auto py-2',
				'[&::-webkit-scrollbar]:hidden [scrollbar-width:none] [-ms-overflow-style:none]',
				className
			)}
		>
			{Array.from({ length: count }).map((_, index) => (
				<div
					key={index}
					className="shrink-0 w-[160px] min-w-[160px] lg:w-[200px] lg:min-w-[200px]"
				>
					<Skeleton className="w-full aspect-square rounded-lg lg:rounded-3xl" />
					<Skeleton className="h-3 lg:h-4 w-3/4 mt-2 lg:mt-3" />
				</div>
			))}
		</div>
	)
}

export default PlaylistSkeleton
